module.exports = __webpack_public_path__ + "img/1f415.ef4b1a8.svg";